module.exports = __webpack_public_path__ + "assets/img/thumb-Blue-Microphones-Langing-page.3d2f49ef.jpg";